import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import { ContactMailOutlined } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Support = (props) => {
  const { t } = useTranslation();
  const { user, url } = props;
  const group = user.signInUserSession.idToken.payload.group;
  const username = user.username;
  const enviroment = process.env.REACT_APP_ENV;
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
  const supportAgentEmail = process.env.REACT_APP_SUPPORT_AGENT_EMAIL;

  const handleClick = () => {
    const mailTo = `mailto:${supportAgentEmail}` +
      `?subject=[SUPPORT ${enviroment}] ` +
      `${t('support:subject')}` +
      ` (App: ${group} - Username: ${username})` +
      `&cc=${supportEmail}` +
      `&body=${t('support:body')}`;
    const supportLink = url || mailTo;
    window.open(supportLink, '_blank');
  };

  return (
    <Tooltip className='lang-changeLang' title={t('toolbar:support:tooltip')}>
      <IconButton
        aria-controls='simple-menu'
        id='support-button'
        aria-haspopup='true'
        onClick={handleClick}
        color='primary'
      >
        <ContactMailOutlined fontSize='large' color='primary' />
      </IconButton>
    </Tooltip>
  );
};

Support.propTypes = {
  user: PropTypes.object.isRequired,
  url: PropTypes.string
};

export default withRouter(memo(Support));
